// Translation index - imports and merges all translation modules
import { commonTranslations } from './common';
import { clerkAuthTranslations } from './clerkAuth';
import { landingTranslations } from './landing';
import { clientTranslations } from './client';
import { managerTranslations } from './manager';

// Helper function to merge translation objects
function mergeTranslations(...translationObjects: Array<Record<string, Record<string, string>>>) {
  const result: Record<string, Record<string, string>> = {
    fr: {},
    en: {},
    zh: {},
  };

  translationObjects.forEach((translations) => {
    Object.keys(translations).forEach((lang) => {
      if (result[lang as keyof typeof result]) {
        result[lang as keyof typeof result] = {
          ...result[lang as keyof typeof result],
          ...translations[lang as keyof typeof translations],
        };
      }
    });
  });

  return result;
}

// Export merged translations
export const translations = mergeTranslations(
  commonTranslations,
  clerkAuthTranslations,
  landingTranslations,
  clientTranslations,
  managerTranslations,
);

